<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="feedbackId"
            :search-url="search_url"
            create-url="/kidFeedback/save"
            delete-url="/kidFeedback/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            :acceptDelete="true"
            :acceptView="false"
            @viewItem="viewItem"
            @setLastSearchValues="setLastSearchValues"
            :lastSearchValues="lastSearchValues"
            orderBy="asc,desc"
            :acceptBack="4001"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/point/FeedbackCreate.vue";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Feedback phụ huynh",
      formCreateName: "",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      search_url: null,
      ageId: null,
      ageName: null,
      levelNumber: null,
      levelId: null,
      weekTotal: null,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value:'createAt',
          text: 'Ngày nhập',
          sortable: false,
          search: true,
          dateFormat: 'dd/MM/yyyy hh:mm',
          width: "15%",
          headerStyle: "text-align:center",
        },
        {
          value: 'feedbackTime',
          text: 'Ngày phụ huynh feedback',
          sortable: false,
          search: true,
          dateFormat: 'dd/MM/yyyy hh:mm',
          width: "15%",
          headerStyle: "text-align:center",
        },
        {
          value: 'feedbackNote',
          text: 'Nội dung feedback',
          sortable: false,
          search: true,
          width: "20%",
          headerStyle: "text-align:center",
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    this.search_url = "/kidFeedback/search/"+ this.$route.params.id;
  },


  methods: {

    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới feedback phụ huynh';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật feedback phụ huynh';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
    setLastSearchValues: function (values) {
      //this.lastSearchValues = Object.assign(this.lastSearchValues, {"searchQT":JSON.stringify(values)});
      this.lastSearchValues = Object.assign(this.lastSearchValues, values);
    },
    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/accountDetail/view/' + item.accountId,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
